export default __webpack_public_path__ + "static/media/topleft.afd5ae84.svg";